import styles from "./StatisticsGeoPanels.module.scss";
import type { StatisticsAccountGeoPoint } from "../../_types/statistics-api.types";
import { StatisticsAccountsMap } from "../statistics-accounts-map";
import { StatisticsFuturePanel } from "../statistics-future-panel";

type StatisticsGeoPanelsProps = {
  geoPoints: StatisticsAccountGeoPoint[] | null;
};

export function StatisticsGeoPanels({ geoPoints }: StatisticsGeoPanelsProps) {
  return (
    <div className={styles["comp"]}>
      <section
        className={styles["comp__column"]}
        aria-labelledby="stats-map-heading"
      >
        <div className={styles["comp__intro"]}>
          <h2 id="stats-map-heading" className={styles["comp__title"]}>
            Account origins
          </h2>
          <p className={styles["comp__description"]}>
            A quick sense of where your accounts join you from across regions.
            <br />
            Based on last known login location, with country fallback when needed.
          </p>
        </div>
        <div className={styles["comp__box"]}>
          <StatisticsAccountsMap geoPoints={geoPoints} />
        </div>
      </section>

      <section
        className={styles["comp__column"]}
        aria-labelledby="stats-future-heading"
      >
        <div className={styles["comp__intro"]}>
          <h2 id="stats-future-heading" className={styles["comp__title"]}>
            Coming soon
          </h2>
          <p className={styles["comp__description"]}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            <br />
            Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </div>
        <div className={styles["comp__box"]}>
          <StatisticsFuturePanel />
        </div>
      </section>
    </div>
  );
}
